module.exports = __webpack_public_path__ + "img/marco_h.0aa7b379.png";